{
  "LOGIN": {
    "TITLE": "Iniciar sesión en Chatwoot",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "ejemplo{'@'}nombredeempresa.com",
      "ERROR": "Por favor, introduzca una dirección de correo válida"
    },
    "PASSWORD": {
      "LABEL": "Contraseña",
      "PLACEHOLDER": "Contraseña"
    },
    "API": {
      "SUCCESS_MESSAGE": "Inicio de sesión exitoso",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde",
      "UNAUTH": "Nombre de usuario / Contraseña incorrecto. Inténtelo de nuevo"
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Iniciar sesión con Google",
      "BUSINESS_ACCOUNTS_ONLY": "Por favor, utiliza el correo electrónico de tu empresa para iniciar sesión",
      "NO_ACCOUNT_FOUND": "No pudimos encontrar una cuenta para tu dirección de correo electrónico."
    },
    "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?",
    "CREATE_NEW_ACCOUNT": "Crear nueva cuenta",
    "SUBMIT": "Iniciar sesión",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
